"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Form_1 = require("./Form");
exports.default = Form_1.default;
//# sourceMappingURL=index.js.map